import React from 'react';
import PropTypes from 'prop-types';
import { SdmTypography, SdmTextButton, SdmSpacer } from 'components';

import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ArrowBack from '@material-ui/icons/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const PageHeader = ({
  i18n,
  isBrandPage = false,
  onCreate,
  onBack,
  hasCustomTitle,
  hasBackBtn = false,
  align = 'flex-end',
  description = '',
  titleCustomStyle = {},
  hideBottomSpace = false,
}) => {
  const mediaTheme = useTheme();
  const isSmDown = useMediaQuery(mediaTheme.breakpoints.down('sm'));
  const isXsDown = useMediaQuery(mediaTheme.breakpoints.down('xs'));
  return (
    <Grid container style={{ backgroundColor: 'white' }}>
      <Grid item xs={12}>
        <Grid container alignItems={align}>
          {hasBackBtn && (
            <Grid item xs={2}>
              <SdmTextButton
                variant="noneInverted"
                text={i18n.buttons.back}
                onClick={() => {
                  onBack && onBack();
                }}
                style={{
                  position: isXsDown ? 'absolute' : 'relative',
                  top: isXsDown ? '3%' : 0,
                  left: isXsDown ? '4%' : 0,
                }}
              >
                <ArrowBack />
              </SdmTextButton>
            </Grid>
          )}
          <Grid item xs={hasBackBtn ? 8 : 12}>
            {i18n?.subtitle ? (
              <SdmTypography
                style={{ textTransform: 'uppercase' }}
                variant={isXsDown ? 'h5Regular' : 'h4Regular'}
                textAlign={'center'}
              >
                {i18n.subtitle}
              </SdmTypography>
            ) : (
              <SdmSpacer height={30} />
            )}
            <SdmTypography
              variant={isXsDown ? 'h1' : 'pageTitle'}
              textAlign={'center'}
              style={titleCustomStyle}
            >
              {hasCustomTitle ? hasCustomTitle : i18n.title}
            </SdmTypography>
            {description ? (
              <SdmTypography
                variant={isSmDown ? 'h5Regular' : 'h2Regular'}
                textAlign={'center'}
                style={{ marginBottom: 15 }}
              >
                {description}
              </SdmTypography>
            ) : null}
          </Grid>
          {hasBackBtn && <Grid item xs={2}></Grid>}
        </Grid>
      </Grid>
      {isBrandPage && (
        <>
          <Grid item sm={3} />
          <Grid item sm={6} xs={12} style={{ textAlign: 'center' }}>
            <SdmTextButton
              height={46}
              textVariant={isSmDown ? 'h6Regular' : 'h2Regular'}
              text={i18n.buttons.createBr}
              variant="redFill"
              onClick={() => {
                onCreate && onCreate();
              }}
            />
          </Grid>
          <Grid item sm={3} />
        </>
      )}
      {!hideBottomSpace ? <SdmSpacer height={30} /> : null}
    </Grid>
  );
};

PageHeader.propTypes = {
  i18n: PropTypes.object.isRequired,
  isBrandPage: PropTypes.bool,
};

export default PageHeader;
